import { render } from "./schedule.vue?vue&type=template&id=2e80e0be"
import script from "./schedule.vue?vue&type=script&lang=js"
export * from "./schedule.vue?vue&type=script&lang=js"
script.render = render

export default script